import React from "react";
import Category from "./Components/Category";

const CategoryListSection = (props) => {
  return (
    <>
      {props.data &&
        props.data.map((item, k) => (
          <Category
            key={k}
            name={item.name}
            displayPostId={props.displayPostId}
            defaultExpanded={props.defaultExpanded}            
            posts={item.libraryPosts}
            handleClickLinkBtn={props.handleClickLinkBtn}
          />
        ))}
    </>
  );
};

export default CategoryListSection;
